// React
import { useCallback, useEffect, useRef, useState } from "react";

// Redux
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Utils
import ICONS from "../../../assets/Icons/index.js";
import TEXT from "../../../utils/globalText.js";
import { globalTextFormat } from "../../../utils/globalTextFormat.js";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";

// Components
import CommonCalendar from "../../_utils/CommonCalendar/index.jsx";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import MultiSelectDropDownComponent from "../../_utils/CommonDropdown/MultiSelectDropdown/index.jsx";
import CommonTimePicker from "../../_utils/CommonDropdown/SetTime/index.jsx";
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import CommonFileUpload from "../../_utils/CommonFileUpload/index.jsx";
import TextInputField from "../../_utils/CommonInputFields/TextInputField.jsx";
import CommonLabelPopup from "../../_utils/CommonPopups/CommonLabelpopup/index.jsx";
import CommonQuantity from "../../_utils/CommonQuantity/index.jsx";
import CommonToggleCard from "../../_utils/TransactionCommonComponents/CommonToggleCard.jsx";
import CommonLayout from "../../_utils/CommonLayout/index.jsx";
import Loader from "../../Loader/Index.jsx";

const FieldForceRequestTxnAdditionalDetails = (props) => {
  const navigate = useNavigate();

  //  useRef
  const dropdownRefs = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  //  useState
  const [dropdowns, setDropdowns] = useState({});
  const [isError, setIsError] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  //  Constants
  const {
    selectedCategory,
    category: assignedCategories = [],
    categories = [],
    mapingCat,
    catSelect,
    setMapingCat,
  } = props;
  const {
    txnPayLoad,
    catName,
    setCatSelect: setCatSelectProp,
    setSelectedCategory: setSelectedCategoryProp,
    handleCategorySelect: onCategorySelect,
    setTxnPayLoad: setTxnPayLoadProp,
    setAdditionalData: setAdditionalDataProp,
    setSelectedValue: setSelectedValueProp,
    setStartDate: setStartDateProp,
    setEndDate: setEndDateProp,
    setStartDateCal: setStartDateCalProp,
    setIsSingleDateSelected: setIsSingleDateSelectedProp,
    setHyperLink: setHyperLinkProp,
    setPreviewImages: setPreviewImagesProp,
    setUploadedFiles: setUploadedFilesProp,
    setTimeData: setTimeDataProp,
    setQuantities: setQuantitiesProp,
    setSelectedValueMonth: setSelectedValueMonthProp,
  } = props;
  const availableCategories = categories;
  const assignedCategoryIds = assignedCategories
    .map((categoryValue) =>
      availableCategories.find(
        (category) =>
          String(category?.id) === String(categoryValue) ||
          category?.name?.trim().toLowerCase() ===
            String(categoryValue)?.trim().toLowerCase(),
      )?.id,
    )
    .filter((categoryId) => categoryId != null);
  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - 1975 + 1 },
    (_, i) => 1975 + i,
  );

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formatDate = (date) => {
    if (!date) return "";
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };
  const handleDateChange = (dates, key, name, type) => {
    const [start, end] = dates;

    props?.setStartDate((prev) => ({
      ...prev,
      [key]: start || null,
    }));

    props?.setEndDate((prev) => ({
      ...prev,
      [key]: end || null,
    }));

    if (start && end) {
      const formattedValue = {
        start_date: formatDate(start),
        end_date: formatDate(end),
      };

      handleInputChange({
        target: {
          name,
          value: formattedValue,
          data_type: type,
        },
      });

      props?.setShowDatePicker((prev) => ({
        ...prev,
        [key]: false,
      }));
    }
  };

  //  useEffect
  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  const handleClearTime = (key, field) => {
    const { [field]: _, ...updatedData } = props?.additionalData;
    props?.setAdditionalData(updatedData);
    props?.setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState.mergeCategory?.map((item) =>
        item.data_type === "time" ? { ...item, value: "" } : item,
      ),
    }));
    props?.setTimeData((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const handleToggle = (fieldName, data_type, value, name) => {
    let newStates = value || false;
    newStates = !newStates;

    handleInputChange({
      target: {
        name: fieldName,
        value: newStates,
        data_typeChan: data_type,
      },
    });
    if (newStates === false) {
      const updatedData = { ...props?.additionalData, [name]: "" };
      props?.setAdditionalData(updatedData);
    }
  };

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (value < 0 || value.length > 15) {
      return;
    }

    props?.setQuantities((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: Number(value) || 0,
        data_typeChan: data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleConfirmCal = (fieldname, data_type, value, key) => {
    if (!value) {
      handleInputChange({
        target: {
          name: fieldname,
          value: "",
          data_typeChan: data_type,
        },
      });

      props?.setStartDateCal((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });

      props?.setIsSingleDateSelected(false);
      return;
    }

    handleInputChange({
      target: {
        name: fieldname,
        value: formatDate(value),
        data_typeChan: data_type,
      },
    });
    props?.setIsSingleDateSelected(true);
  };

  const handleFileChange = (file, key, field) => {
    if (!field) return;

    const isRealFile = file instanceof File;

    props?.setUploadedFiles((prev) => {
      const updated = { ...prev };
      if (isRealFile) {
        updated[key] = file;
      } else {
        delete updated[key];
      }
      return updated;
    });

    if (isRealFile && file.type?.startsWith("image/")) {
      const reader = new FileReader();

      reader.onload = () => {
        props?.setPreviewImages((prev) => ({ ...prev, [key]: reader.result }));
      };
      reader.readAsDataURL(file);
    } else {
      props?.setPreviewImages((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
    }

    handleInputChange({
      target: {
        name: field?.name,
        value: isRealFile ? file : "",
        data_typeChan: field?.data_type,
      },
    });
  };

  const handleChange = (value, field, key) => {
    props?.setHyperLink((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: field?.name,
        value: value,
        data_typeChan: field?.data_type,
      },
    });
  };

  const clearField = (field, key) => {
    const { [field.name]: _, ...updatedData } = props?.additionalData;
    props?.setAdditionalData(updatedData);
    props?.setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState.mergeCategory?.map((item) =>
        item.data_type === "hyperlink" ? { ...item, value: "" } : item,
      ),
    }));
    props?.setHyperLink((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
    props?.setInitialRefactorAdditionalDetail((prev) => ({
      ...prev,
      [field.name]: {
        ...prev[field.name],
        isCopyClick: false,
        isPaste: {},
      },
    }));
  };

  const handleInputChange = (e, data_type) => {
    if (data_type === "numeric" && e.target.value.length > 15) return;
    if (e.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: data_typeChan,
    } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (f) => f.name === name,
      );

    let updatedData = { ...props.additionalData };

    const isNonTrimmedType = [
      "date",
      "year",
      "toggle",
      "time",
      "quantity",
      "from_year_to_year",
      "month_year",
      "date_range",
      "multi_select_list",
      "upload",
    ].includes(data_typeChan);

    const trimmedValue =
      isNonTrimmedType || typeof value !== "string"
        ? value
        : value.replace(/^\s+/, "");

    if (field?.data_type === "month_year") {
      if (typeof value === "object" && value?.month && value?.year) {
        const monthNumber = (months.indexOf(value.month) + 1)
          .toString()
          .padStart(2, "0");

        updatedData[name] = `${monthNumber}/${value.year}`;
      } else if (typeof value === "string" && value.includes("/")) {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "date_range") {
      if (typeof value === "string" && value.includes("-")) {
        const [start, end] = value.split("-").map((v) => v.trim());
        updatedData[name] = {
          start_date: start,
          end_date: end,
        };
      } else if (typeof value === "object") {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "numeric") {
      if (trimmedValue === "" || /^\d+$/.test(trimmedValue)) {
        updatedData[name] = trimmedValue;
      }
    } else {
      updatedData[name] = trimmedValue;
    }

    props.setAdditionalData(updatedData);

    if (field?.data_type === "list") {
      setDropdowns((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          selectedOption: trimmedValue,
        },
      }));
    }

    return;
  };

  useEffect(() => {
    if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "time"
    ) {
      const timeStr = props?.copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        props?.copyData?.title,
        props?.copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      props?.setTimeData((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,
          value: props?.copyData?.value,
          data_typeChan: props?.copyData?.data_type,
        },
      });

      let data = new Date(props?.copyData?.value);

      props?.setStartDateCal((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,
          [key]: data,
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        props?.copyData?.value || 0,
        props?.copyData?.title,
        props?.copyData?.data_type,
        `${props?.copyData?.title}_${props?.copyData?.data_type}`,
      );

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = props?.copyData?.value.split("/");

      const monthIndex = parseInt(monthStr, 10) - 1;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [monthName, parseInt(yearStr, 10)];

      props?.setSelectedValueMonth((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setSelectedValue((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: props?.copyData?.value?.from,

            to: props?.copyData?.value?.to,
          },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date_range"
    ) {
      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [props?.copyData]);

  useEffect(() => {
    props.BenEnableNextButton(true);
  }, []);

  useEffect(() => {
    if (!props.additionalData) return;

    const storeData =
      props.txnPayLoad.selectedCategory?.configuration?.data?.map((val) => {
        const dataValue = props.additionalData[val?.name];

        if (
          dataValue !== undefined &&
          (Array.isArray(dataValue)
            ? dataValue.length > GlobalConfiguration?.lengthCheckZero
            : dataValue !== "")
        ) {
          if (val?.data_type === "numeric") {
            return {
              ...val,
              value: String(dataValue),
            };
          }

          return { ...val, value: dataValue };
        }
        switch (val?.data_type) {
          case "multi_select_list":
            return { ...val, value: [] };

          case "toggle":
            return { ...val, value: false };

          case "hyperlink":
          case "upload":
            return { ...val, value: "" };

          case "date":
            return { ...val, value: "" };

          case "time":
            return val;

          default:
            return val?.mandatory !== "Y" ? { ...val, value: "" } : val;
        }
      });

    props.setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
    const timer = setTimeout(() => {
      setIsCategoryLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [props?.additionalData, props?.txnPayLoad.selectedCategory]);

  const renderInputFields = () => {
    if (
      !selectedCategory ||
      !selectedCategory.configuration ||
      !selectedCategory.configuration.data ||
      selectedCategory.configuration.data.length === 0
    ) {
      return (
        <div className="text-left text-text-primary text-sm antialiased">
          {TEXT.ADDITIONAL_DETAILS_UNSUPPORTED}
        </div>
      );
    }

    return props?.txnPayLoad?.mergeCategory?.map((field, index) => {
      const isFieldRequired = field.mandatory === "Y";
      const optionalLabel = isFieldRequired ? "" : " (optional)";
      const fieldValue = props?.additionalData[field.name] || "";
      switch (field?.data_type) {
        case "string":
        case "numeric":
          return (
            <TextInputField
              placeholder={`${field.name}${optionalLabel}`}
              name={field.name}
              value={fieldValue || ""}
              fontKind="big"
              bgColor="var(--primary-card)"
              variant="default"
              fgColor="var(--text-primary)"
              adornment={
                props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
                  ?.value
                  ? ICONS?.PASTE_WHITE_GREEN_BG
                  : ""
              }
              onAdornmentClick={
                props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
                  ?.value &&
                (() => {
                  props?.setAdditionalData((prev) => ({
                    ...prev,
                    [field.name]:
                      props?.initialRefactorAdditionalDetail?.[field.name]
                        ?.isPaste?.value,
                  }));
                  props?.setInitialRefactorAdditionalDetail((prev) => ({
                    ...prev,
                    [field.name]: {
                      ...prev[field.name],
                      isPaste: {},
                    },
                  }));
                })
              }
              isFullWidth={true}
              onInput={(e) => handleInputChange(e, field?.data_type)}
            />
          );
        case "list":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={field?.data || []}
                selected={field?.value || ""}
                setSelected={(val) =>
                  handleInputChange({
                    target: { name: field.name, value: val },
                  })
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={field?.disabled}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
                isOpen={false}
              />
            </div>
          );
        case "hyperlink":
          const keyHyper = `${field.name}_${field.data_type}`;
          const currentValue = props?.hyperLink?.[keyHyper] || "";

          const pasteValue =
            props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
              ?.value;
          const showAdornment = currentValue !== "" || pasteValue;

          return (
            <TextInputField
              value={currentValue}
              onInput={(e) => handleChange(e.target.value, field, keyHyper)}
              placeholder={`${field.name}${optionalLabel}`}
              name={`${keyHyper}`}
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              variant="default"
              isFullWidth={true}
              adornment={
                showAdornment
                  ? pasteValue
                    ? ICONS?.PASTE_WHITE_GREEN_BG
                    : ICONS.CLOSE
                  : ""
              }
              onAdornmentClick={
                pasteValue
                  ? () => {
                      handleChange(pasteValue, field, keyHyper);
                      props?.setInitialRefactorAdditionalDetail((prev) => ({
                        ...prev,
                        [field?.name]: {
                          ...prev[field?.name],
                          isPaste: {},
                        },
                      }));
                    }
                  : showAdornment
                    ? () => clearField(field, keyHyper)
                    : undefined
              }
            />
          );
        case "time":
          const keyTime = `${field.name}_${field.data_type}`;
          const currentValueHours = props?.timeData?.[keyTime]?.hours || "";
          const currentValueMinutes = props?.timeData?.[keyTime]?.minutes || "";

          let isTimeSelectedShowButton =
            currentValueHours !== "" &&
            currentValueMinutes !== "" &&
            field?.value !== undefined;
          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className="font-normal text-font-xs capitalize"
                style={{
                  color: field?.value
                    ? "var(--text-primary)"
                    : "var(--text-secondary)",
                  textTransform: "capitalize",
                }}
              >
                {`${field.name}${optionalLabel}`}
              </p>
              <CommonTimePicker
                handleTimeConfirm={handleTimeConfirm}
                handleClearTime={handleClearTime}
                value={isTimeSelectedShowButton ? field?.value : ""}
                data_type={field?.data_type}
                fieldname={field.name}
                keyTime={keyTime}
                timeData={props?.timeData}
                setTimeData={props?.setTimeData}
              />
            </div>
          );
        case "day":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={days}
                selected={field?.value || ""}
                setSelected={(value) =>
                  handleInputChange(
                    { target: { name: field?.name, value } },
                    field?.data_type,
                  )
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={false}
                isOpen={false}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "toggle":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <CommonToggleCard
                description={field?.description}
                state={field?.value}
                isDisabled={field?.disabled}
                handleClick={() =>
                  handleToggle(
                    field?.name,
                    field?.data_type,
                    field?.value,
                    field?.name,
                  )
                }
              />
            </div>
          );
        case "month":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={months}
                selected={field?.value || ""}
                setSelected={(value) =>
                  handleInputChange(
                    { target: { name: field?.name, value } },
                    field?.data_type,
                  )
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={false}
                isOpen={false}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "upload":
          const key = `${field.name}_${field.data_type}`;
          const file = props?.uploadedFiles[key];
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">
                {`${field.name === "File" ? "Upload File" : field.name}${optionalLabel}`}
              </p>
              <CommonFileUpload
                id={key}
                files={file || []}
                setFiles={(selectedFile) => {
                  handleFileChange(selectedFile, key, field);
                }}
                isDisabled={false}
              />
            </div>
          );

        case "date":
          const keyDate = `${field.name}_${field.data_type}`;
          const currentValueDate = props?.startDateCal?.[keyDate] || "";
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <CommonCalendar
                startDate={currentValueDate}
                selectionType="single"
                type="big"
                handleDateChange={(selectedDate) => {
                  handleConfirmCal(
                    field?.name,
                    field?.data_type,
                    selectedDate,
                    keyDate,
                  );
                }}
              />
            </div>
          );
        case "multi_select_list":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <MultiSelectDropDownComponent
                options={field?.data || []}
                selected={field?.value || []}
                setSelected={(newSelected) =>
                  handleInputChange({
                    target: {
                      name: field?.name,
                      value: newSelected,
                    },
                  })
                }
                isOpen={false}
                showSearch={false}
                placeholder={TEXT?.SELECT}
                disabled={false}
                type="big"
                onOpen={() => props?.setShowDatePicker?.(false)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "year":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={years}
                selected={field?.value || ""}
                setSelected={(val) => {
                  handleInputChange({
                    target: {
                      name: field.name,
                      value: val,
                      data_type: field?.data_type,
                    },
                  });
                }}
                isOpen={false}
                showSearch={false}
                placeholder={TEXT?.SELECT}
                disabled={false}
                type="big"
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );

        case "quantity":
          const keyQuantity = `${field.name}_${field.data_type}`;
          const currentValueQuantity =
            props?.quantities?.[keyQuantity] || field?.value || 0;

          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                htmlFor={keyQuantity}
                id="uploadId"
                className={`text-font-xs ${
                  props?.isSingleDateSelected
                    ? "text-text-primary"
                    : "text-text-secondary"
                }`}
              >
                {`${field.name}${optionalLabel}`}
              </p>
              <CommonQuantity
                quantity={currentValueQuantity}
                setQuantity={(val) => {
                  props?.setQuantities?.((prev) => ({
                    ...prev,
                    [keyQuantity]: val,
                  }));

                  handleInputChange(
                    {
                      target: {
                        name: field.name,
                        value: val,
                      },
                    },
                    field?.data_type,
                  );
                }}
                isDisabled={false}
              />
            </div>
          );

        case "from_year_to_year":
          const keyYear = `${field.name}_${field.data_type}`;
          const currentYear = props?.selectedValue?.[keyYear] || {
            from: "",
            to: "",
          };

          const fromOptions = currentYear.to
            ? years.filter((year) => year <= currentYear.to)
            : years;

          const toOptions = currentYear.from
            ? years.filter((year) => year >= currentYear.from)
            : years;

          return (
            <div className="w-width-full">
              <div className="flex flex-row gap-gap-md w-width-full">
                <div className="w-width-md flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>
                  <SingleSelectDropDownComponent
                    options={fromOptions}
                    selected={currentYear.from || ""}
                    setSelected={(value) => {
                      const updatedYear = { ...currentYear, from: value };

                      props?.setSelectedValue?.((prev) => ({
                        ...prev,
                        [keyYear]: updatedYear,
                      }));

                      handleInputChange(
                        { target: { name: field?.name, value: updatedYear } },
                        field?.data_type,
                      );
                    }}
                    type="big"
                    placeholder={TEXT?.SELECT}
                    isOpen={props.showYearDrop?.[`${keyYear}_from`] || false}
                    showSearch={false}
                    onOpen={() =>
                      props.setShowYearDrop({
                        [`${keyYear}_from`]: true,
                        [`${keyYear}_to`]: false,
                      })
                    }
                    onClose={() =>
                      props.setShowYearDrop((prev) => ({
                        ...prev,
                        [`${keyYear}_from`]: false,
                      }))
                    }
                  />
                </div>

                <div className="w-width-md flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>

                  <SingleSelectDropDownComponent
                    options={toOptions}
                    selected={currentYear.to || ""}
                    setSelected={(value) => {
                      const updatedYear = { ...currentYear, to: value };

                      props?.setSelectedValue?.((prev) => ({
                        ...prev,
                        [keyYear]: updatedYear,
                      }));

                      handleInputChange(
                        { target: { name: field?.name, value: updatedYear } },
                        field?.data_type,
                      );
                    }}
                    type="big"
                    placeholder={TEXT?.SELECT}
                    isOpen={props.showYearDrop?.[`${keyYear}_to`] || false}
                    showSearch={false}
                    onOpen={() =>
                      props.setShowYearDrop({
                        [`${keyYear}_from`]: false,
                        [`${keyYear}_to`]: true,
                      })
                    }
                    onClose={() =>
                      props.setShowYearDrop((prev) => ({
                        ...prev,
                        [`${keyYear}_to`]: false,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          );
        case "month_year":
          const keyMonthYear = `${field.name}_${field.data_type}`;
          const currentMonthYear = props?.selectedValueMonth[keyMonthYear] || {
            month: "",
            year: "",
          };

          return (
            <div className="flex gap-gap-md w-width-full">
              <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs">
                  {`${field.name}${optionalLabel}`}
                </p>
                <SingleSelectDropDownComponent
                  options={months}
                  selected={currentMonthYear.month || ""}
                  setSelected={(val) => {
                    props?.setSelectedValueMonth((prev) => ({
                      ...prev,
                      [keyMonthYear]: { ...prev[keyMonthYear], month: val },
                    }));
                    handleInputChange({
                      target: {
                        name: field?.name,
                        value: { ...currentMonthYear, month: val },
                      },
                    });
                  }}
                  isOpen={false}
                  showSearch={false}
                  placeholder={TEXT?.SELECT}
                  disabled={false}
                  type="big"
                  onOpen={() => props?.setShowDatePicker?.(false)}
                  onClose={() => props?.setShowDatePicker?.(false)}
                />
              </div>

              <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs">
                  {`${field.name}${optionalLabel}`}
                </p>
                <SingleSelectDropDownComponent
                  options={years}
                  selected={currentMonthYear.year || ""}
                  setSelected={(val) => {
                    props?.setSelectedValueMonth((prev) => ({
                      ...prev,
                      [keyMonthYear]: { ...prev[keyMonthYear], year: val },
                    }));
                    handleInputChange({
                      target: {
                        name: field?.name,
                        value: { ...currentMonthYear, year: val },
                      },
                    });
                  }}
                  isOpen={false}
                  showSearch={false}
                  placeholder={TEXT?.SELECT}
                  disabled={false}
                  type="big"
                  onOpen={() => props?.setShowDatePicker?.(false)}
                  onClose={() => props?.setShowDatePicker?.(false)}
                />
              </div>
            </div>
          );

        case "date_range":
          const keyMultiDate = `${field.name}_${field.data_type}`;

          const currentValueFromDate = props?.startDate?.[keyMultiDate] ?? null;
          const currentValueToDate = props?.endDate?.[keyMultiDate] ?? null;

          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">
                {`${field.name}${optionalLabel}`}
              </p>

              <CommonCalendar
                selectionType="range"
                type="big"
                startDate={currentValueFromDate}
                endDate={currentValueToDate}
                handleDateChange={(dates) => {
                  handleDateChange(
                    dates,
                    keyMultiDate,
                    field?.name,
                    field?.data_type,
                  );
                }}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  //  Constants
  const disableCategories = true;
  const unassignCategories = availableCategories.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !assignedCategoryIds.includes(unassignCategory.id),
  );

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("AvailableLabelsTxn");
    const accountTxnRaw = sessionStorage.getItem("AvailableLabels");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    const uniqueLabels = [...new Set(initialLabels)];

    setLabels(uniqueLabels);
  }, []);

  useEffect(() => {
    const ownerLabels = props?.txnPayLoad?.ownerLabels || [];
    const labels = props?.txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [props?.txnPayLoad?.ownerLabels, props?.txnPayLoad?.labels]);

  const handleClose = () => {
    setShowLabelModal(false);

    const currentOwnerLabels = props?.txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = selectedLabelsCreate.filter((label) =>
      currentOwnerLabels.includes(label),
    );

    const newOtherLabels = selectedLabelsCreate.filter(
      (label) => !currentOwnerLabels.includes(label),
    );

    props?.setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  const handleCategorySelect = useCallback((category) => {
    const categoryData = availableCategories.find(
      (cat) =>
        String(cat?.id) === String(category) ||
        cat?.name?.trim().toLowerCase() ===
          String(category)?.trim().toLowerCase(),
    );
    if (!categoryData) return;

    if (String(selectedCategory?.id) === String(categoryData.id)) {
      return;
    }
    setIsCategoryLoading(true);
    if (txnPayLoad?.selectedCategory?.name === catName) {
      setCatSelectProp?.(false);
    }
    setSelectedCategoryProp?.(categoryData);
    onCategorySelect?.(categoryData);
    setTxnPayLoadProp?.({
      ...txnPayLoad,
      selectedCategory: categoryData,
    });
    setAdditionalDataProp?.({});
    setSelectedValueProp?.({ from: "Select", to: "Select" });
    setStartDateProp?.({});
    setEndDateProp?.({});
    setStartDateCalProp?.({});
    setIsSingleDateSelectedProp?.(false);
    setHyperLinkProp?.({});
    setPreviewImagesProp?.({});
    setUploadedFilesProp?.({});
    setTimeDataProp?.({});
    setQuantitiesProp?.({});
    setSelectedValueMonthProp?.({});
  }, [
    availableCategories,
    selectedCategory?.id,
    txnPayLoad,
    catName,
    setCatSelectProp,
    setSelectedCategoryProp,
    onCategorySelect,
    setTxnPayLoadProp,
    setAdditionalDataProp,
    setSelectedValueProp,
    setStartDateProp,
    setEndDateProp,
    setStartDateCalProp,
    setIsSingleDateSelectedProp,
    setHyperLinkProp,
    setPreviewImagesProp,
    setUploadedFilesProp,
    setTimeDataProp,
    setQuantitiesProp,
    setSelectedValueMonthProp,
  ]);

  useEffect(() => {
    if (mapingCat === "renderCat" && catSelect) {
      handleCategorySelect(beneTxnAccountData?.transaction?.[0]?.category);
      setMapingCat?.(null);
    }
  }, [
    mapingCat,
    catSelect,
    setMapingCat,
    beneTxnAccountData?.transaction,
    handleCategorySelect,
  ]);

  const handleUnassignNavigate = (id) => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories/${id}`,
    );
  };

  useEffect(() => {
    if (assignedCategories.length === GlobalConfiguration?.lengthCheckOne) {
      handleCategorySelect(assignedCategories[0]);
    }
  }, [availableCategories, assignedCategories, handleCategorySelect]);

  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonLabelPopup
            headerTitle="Assign Labels"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closeisLoading={false}
            closehandleFunction={handleClose}
            closeenabledBgColor="var(--primary-nav-act)"
            closebtnType="button"
            closeisDisabled={false}
            closedisabledBgColor=""
            ctabtnText="Assign new label"
            ctaplaceholder="Search / enter new label"
            labelsubtext="Existing labels"
            nolablefound="No existing labels found."
            labels={labels}
            setLabels={setLabels}
            setPayload={props?.setTxnPayLoad}
            txnPayLoad={
              props?.txnPayLoad?.labels && props?.txnPayLoad?.ownerLabels
            }
            type="create"
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={(x) => {
              setSelectedLabelsCreate(x);
            }}
            isLabelPopupOpen={showLabelModal}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
          />
        </div>
      )}
      <div
        className="w-width-full Qlg:px-padding-base px-padding-md py-padding-lg max-w-tab-width-normal mx-auto"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          {/* Part 1 */}
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            {isError ? null : (
              <CategorySelector
                beneAccountId={beneAccountId}
                category={assignedCategoryIds}
                selectedCategory={props?.selectedCategory}
                // unassignCategories={unassignCategories}
                unassignlength={unassignlength}
                disableCategories={disableCategories}
                handleCategorySelect={handleCategorySelect}
                handleUnassignNavigate={handleUnassignNavigate}
                previewMode={false}
                enableSearch={assignedCategories.length !== 1}
                showUnassignCTA={false}
              />
            )}
          </div>
          {/* Part 1 */}

          {/* Part 2 */}
          <div
            className={`bg-primary-card py-padding-md h-auto flex flex-col px-padding-md items-start rounded-border-radius-md 
              ${
                selectedCategory &&
                selectedCategory.configuration &&
                selectedCategory.configuration.data &&
                selectedCategory.configuration.data.length > 0
                  ? "gap-gap-md"
                  : "gap-gap-xs"
              }`}
          >
            <div className=" w-width-full text-text-primary font-semibold text-font-md flex flex-row justify-between">
              Category Specific Details
            </div>
            <div className="w-width-full flex flex-col gap-gap-md">
              {isCategoryLoading ? (
                <div className="w-full flex justify-center items-center pt-padding-md">
                  <Loader
                    width="var(--icon-lg)"
                    height="var(--icon-lg)"
                  />
                </div>
              ) : selectedCategory ? (
                renderInputFields()
              ) : (
                <div className="text-text-secondary text-font-xs font-normal">
                  Select a category to fetch the category-specific details.
                </div>
              )}
            </div>
          </div>
          {/* Part 2 */}
        </CommonLayout>
      </div>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block my-margin-xl mt-margin-base lg:my-margin-base"></div>
    </>
  );
};

export default FieldForceRequestTxnAdditionalDetails;
